export default __webpack_public_path__ + "assets/images/5.5889e4.png";